import type { Property } from '@cognitoforms/model.js';

/**
 * Handles selection type migration (single-select <--> multi-select) during deserialization.
 *
 * When a selection field's type changes, existing entry data may have the old format.
 * This function transforms values to match the current field configuration.
 *
 * Used by both ChoiceFieldConverter and LookupConverter.
 *
 * @param value The value to migrate
 * @param property The property with the current field configuration (isList indicates multi-select)
 * @returns The migrated value matching the property's current selection type
 */
export function migrateSelectionValue(value: any, property: Property): any {
	if (value == null)
		return value;

	// Single→Multi: property expects array but value is not array
	if (property.isList && !Array.isArray(value)) {
		// Empty string becomes empty array (matches server behavior)
		return value === '' ? [] : [value];
	}

	// Multi→Single: property expects single but value is array
	if (!property.isList && Array.isArray(value)) {
		return value.length > 0 ? value[0] : null;
	}

	// Value is already in correct format
	return value;
}
